/** Shared public ads fetch with short memory TTL so sidebar + banner stay in sync and fast. */

const ADS_TTL_MS = 60_000;

let cached = null;
let cachedAt = 0;
let inflight = null;

export function getCachedPublicAds() {
  return cached;
}

export function invalidatePublicAdsCache() {
  cached = null;
  cachedAt = 0;
}

export async function fetchPublicAds(api, { force = false } = {}) {
  if (!force && cached && Date.now() - cachedAt < ADS_TTL_MS) return cached;
  if (inflight) return inflight;

  inflight = (async () => {
    // Prefer HTTP cache when force is false; only bust when admin forced refresh.
    const url = force ? `${api}/api/ads?t=${Date.now()}` : `${api}/api/ads`;
    const res = await fetch(url, {
      cache: force ? 'no-store' : 'default',
      headers: { Accept: 'application/json' },
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok && res.status >= 500) {
      throw new Error(data.error || 'ads_unavailable');
    }
    const next = {
      sidebar: Array.isArray(data.sidebar) ? data.sidebar : [],
      banner: Array.isArray(data.banner) ? data.banner : [],
    };
    if (res.ok || next.sidebar.length || next.banner.length) {
      cached = next;
      cachedAt = Date.now();
    }
    return cached || next;
  })().finally(() => {
    inflight = null;
  });

  return inflight;
}
